import { render, staticRenderFns } from "./borrower.component.vue?vue&type=template&id=cf76fd0e&scoped=true"
import script from "./borrower.component.vue?vue&type=script&lang=ts"
export * from "./borrower.component.vue?vue&type=script&lang=ts"
import style0 from "../style.scss?vue&type=style&index=0&id=cf76fd0e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf76fd0e",
  null
  
)

export default component.exports